//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoDatepickerBasic from './demos/DemoDatepickerBasic.vue'
import DemoDatepickerColors from './demos/DemoDatepickerColors.vue'
import DemoDatepickerReadonlyAndDisabled from './demos/DemoDatepickerReadonlyAndDisabled.vue'
import DemoDatepickerAllowedDates from './demos/DemoDatepickerAllowedDates.vue'
import DemoDatepickerIcons from './demos/DemoDatepickerIcons.vue'
import DemoDatepickerMultiple from './demos/DemoDatepickerMultiple.vue'
import DemoDatepickerSync from './demos/DemoDatepickerSync.vue'
import DemoDatepickerRange from './demos/DemoDatepickerRange.vue'
import DemoDatepickerShowSiblingMonths from './demos/DemoDatepickerShowSiblingMonths.vue'
import DemoDatepickerWidth from './demos/DemoDatepickerWidth.vue'
import DemoDatepickerDateButton from './demos/DemoDatepickerDateButton.vue'
import DemoDatepickerBirthdayPicker from './demos/DemoDatepickerBirthdayPicker.vue'
import DemoDatepickerDialogAndMenu from './demos/DemoDatepickerDialogAndMenu.vue'
import DemoDatepickerFormatting from './demos/DemoDatepickerFormatting.vue'
import DemoDatepickerInternationalization from './demos/DemoDatepickerInternationalization.vue'

// code
import {
  datepickerBasic,
  datepickerColors,
  datepickerReadonlyAndDisabled,
  datepickerAllowedDates,
  datepickerIcons,
  datepickerMultiple,
  datepickerSync,
  datepickerRange,
  datepickerShowSiblingMonths,
  datepickerWidth,
  datepickerDateButton,
  datepickerBirthdayPicker,
  datepickerDialogAndMenu,
  datepickerFormatting,
  datepickerInternationalization,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoDatepickerBasic,
    DemoDatepickerColors,
    DemoDatepickerReadonlyAndDisabled,
    DemoDatepickerAllowedDates,
    DemoDatepickerIcons,
    DemoDatepickerMultiple,
    DemoDatepickerSync,
    DemoDatepickerRange,
    DemoDatepickerShowSiblingMonths,
    DemoDatepickerWidth,
    DemoDatepickerDateButton,
    DemoDatepickerBirthdayPicker,
    DemoDatepickerDialogAndMenu,
    DemoDatepickerFormatting,
    DemoDatepickerInternationalization,
  },
  setup() {
    return {
      codeSnippets: {
        datepickerBasic,
        datepickerColors,
        datepickerReadonlyAndDisabled,
        datepickerAllowedDates,
        datepickerIcons,
        datepickerMultiple,
        datepickerSync,
        datepickerRange,
        datepickerShowSiblingMonths,
        datepickerWidth,
        datepickerDateButton,
        datepickerBirthdayPicker,
        datepickerDialogAndMenu,
        datepickerFormatting,
        datepickerInternationalization,
      },
    }
  },
}
